import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.phoneNumberManagement;
const path = 'individual-number-porting';
const title =
  'PAGE.MOBILE.PHONE_NUMBER_MANAGEMENT.INDIVIDUAL_NUMBER_PORTING.TITLE';

const res = [
  'portNumber',
  'actions',
  'actions.history',
  'actions.cancel',
  'actions.retry',
  'actions.copyPortingRequestId',
];

export const MobilePhoneNumberManagementIndividualNumberPortingTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
